import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Recycle-Bin-2--Streamline-Flex"
    >
        <desc>{'Recycle Bin 2 Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="recycle-bin-2--remove-delete-empty-bin-trash-garbage">
            <path
                id="Vector 195"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.5 4.01121c3.70225 -0.48695 7.29775 -0.48695 11 0"
                strokeWidth={1}
            />
            <path
                id="Subtract"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.48113 3.89331c-0.03491 1.86889 -0.08342 5.02765 0.49568 7.61009 0.22419 0.9997 1.07518 1.7149 2.08968 1.8579 0.65577 0.0925 1.25364 0.1387 1.93361 0.1387 0.68 0 1.27796 -0.0462 1.93382 -0.1387 1.0145 -0.143 1.86548 -0.8582 2.08968 -1.8579 0.5791 -2.58241 0.5306 -5.74115 0.4957 -7.61005 -3.03257 -0.32979 -6.00563 -0.32981 -9.03817 -0.00004Z"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.41786 3.70312c-0.00772 -0.10103 -0.01161 -0.50235 -0.01161 -0.60949C4.40625 1.43371 5.33996 0.5 6.99988 0.5s2.59363 0.93371 2.59363 2.59363c0 0.10714 -0.00389 0.50846 -0.01162 0.60949"
                strokeWidth={1}
            />
            <path
                id="Subtract_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.3476 6.40408c-0.05908 1.0462 -0.00048 2.90177 0.18132 4.24122m2.94168 0c0.18175 -1.33949 0.24026 -3.19505 0.18117 -4.24125"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
